import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["panel"]
  static values = { url: String }

  toggle() {
    if (this.panelTarget.classList.contains("loaded")) {
      this.panelTarget.classList.toggle("open")
      return
    }

    Rails.ajax({
      type: "GET",
      url: this.urlValue,
      success: () => {
        this.panelTarget.classList.add("loaded")
      },
      error: (err) => {
        console.error("Error loading side panel:", err)
        const body = this.panelTarget.querySelector("[class$='body']")
        if (body) body.innerHTML = '<p class="text-danger">Failed to load.</p>'
      }
    })
  }
}
